<div class="main-container payment-status-page">
  <div class="content-wrapper payment-status-wrapper">
    <div class="container payment-status-container">
      <div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading payment status">
        <span class="spinner-border" aria-hidden="true"></span>
        <p class="mt-3 mb-0">Please do not close this page. Wait while we load your transaction status.</p>
      </div>
      <div *ngIf="!isLoading" class="payment-status-card" [ngClass]="getStatusClass()">
        <div class="payment-status-header">
          <div class="status-graphic">
            <div class="status-icon-ring">
              <i class="bi" [ngClass]="getStatusIcon()"></i>
            </div>
          </div>
          <div class="status-copy">
            <p class="status-eyebrow">Transaction Status</p>
            <h3>{{getStatusTitle()}}</h3>
            <p>{{getStatusMessage()}}</p>
          </div>
        </div>

        <div class="payment-status-section">
          <label class="payment-section-title">Booking Summary</label>
          <table class="table table-borderless payment-detail-table">
            <tr>
              <td>BOOKING ID</td>
              <td>{{confirmationId}}</td>
            </tr>
            <tr>
              <td>STATUS</td>
              <td>
                <span class="status-pill" [ngClass]="getStatusClass()">{{getTransactionStatus() || 'Loading'}}</span>
              </td>
            </tr>
            <tr *ngIf="getPaymentType(bookings?.[0])">
              <td>PAYMENT TYPE</td>
              <td>{{getPaymentType(bookings?.[0])}}</td>
            </tr>
            <tr *ngIf="getPlatformFeeEndUser() > 0">
              <td>PLATFORM FEE (END USER)</td>
              <td>Rs. {{getPlatformFeeEndUser() | number:'1.2-2'}}</td>
            </tr>
            <tr *ngIf="getTotalAmount() > 0">
              <td>TOTAL AMOUNT</td>
              <td>Rs. {{getTotalAmount() | number:'1.2-2'}}</td>
            </tr>
          </table>
        </div>

        <div class="payment-status-section" *ngIf="bookings && bookings.length > 0">
          <label class="payment-section-title">Customer Details</label>
          <table class="table table-borderless payment-detail-table">
            <tr>
              <td>NAME</td>
              <td>{{getUserFullName(bookings?.[0])}}</td>
            </tr>
            <tr>
              <td>PHONE</td>
              <td>{{getUserPhoneNumber(bookings?.[0])}}</td>
            </tr>
            <tr>
              <td>EMAIL</td>
              <td>{{getUserName(bookings?.[0])}}</td>
            </tr>
          </table>
        </div>

        <div class="payment-status-section slot-info-section" *ngIf="slotBookings.length > 0">
          <label class="payment-section-title">Slot Information</label>
          <div class="payment-slot-card" *ngFor="let booking of slotBookings; let i = index">
            <div class="slot-card-header">
              <span>Slot {{i + 1}}</span>
              <strong>{{getVenueName(booking)}}</strong>
            </div>
            <div class="slot-metrics-row">
              <span>{{getBookingDateConverted(booking)}}</span>
              <span>{{getStartTime(booking)}} - {{getEndTime(booking)}}</span>
              <strong>Rs. {{getAmount(booking) | number:'1.2-2'}}</strong>
            </div>
          </div>
        </div>

        <div class="payment-status-section" *ngIf="addOnBookings.length > 0">
          <label class="payment-section-title">Add-ons</label>
          <div class="payment-slot-card" *ngFor="let booking of addOnBookings; let i = index">
            <div class="slot-card-header">
              <span>Add-on {{i + 1}}</span>
              <strong>{{booking.productName || 'Add-on'}}</strong>
            </div>
            <div class="slot-metrics-row">
              <span>Qty: {{getAddOnQuantity(booking) ?? 'Not recorded'}}</span>
              <span *ngIf="getAddOnUnitPrice(booking) !== null; else missingUnitPrice">Unit price: Rs. {{getAddOnUnitPrice(booking) | number:'1.2-2'}}</span>
              <ng-template #missingUnitPrice><span>Unit price: Not recorded</span></ng-template>
              <strong>Rs. {{getAmount(booking) | number:'1.2-2'}}</strong>
            </div>
          </div>
        </div>

        <div class="payment-status-actions">
          <button type="button" class="btn booking-cancel-action" (click)="browseMoreVenues()">Browse More Venues</button>
          <button type="button" class="btn booking-pay-action" (click)="goToMyBookings()">My Bookings</button>
        </div>
      </div>
    </div>
  </div>
</div>
